export const FEATURE_FLAG_ANALYTICS = "FEATURE_FLAG_ANALYTICS";
